import src from "IMAGE";
export default { src, width: 166, height: 106, blurWidth: 0, blurHeight: 0};
